/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { DenverMattressService } from "app/services/denver-mattress.service";
import { ValidationInfo } from "app/services/denver-mattress.service";

@Injectable()
export class DenverMattressPortalValidationStateResolver implements Resolve<ValidationInfo> {

    constructor(
        private denverMattressService: DenverMattressService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ValidationInfo> {
        // Get the 'ID' Path parameter which is the ID of the Service to obtain...
        const id = route.paramMap.get('id');
        console.log(`Obtaining State for ID: '${id}'...`);
        console.log("State Info obtained :" + state);

        if (id == null || id.length == 0) {
            return null;
        }

        return await this.denverMattressService.getValidationInfo(id).toPromise();
    }

}
